import { clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

/**
 * Merge Tailwind class names intelligently (shadcn/ui helper).
 */
export function cn(...inputs) {
  return twMerge(clsx(inputs));
}
